export default class CurrentUser {
  accessToken: string
  role: string

  codeUsager: string
  languePreferee: string

  demandeur: {}
  clientData: {}
  infosClientJDE: {}

  static from(usagerData) {
    return usagerData != null ? new CurrentUser(usagerData) : null
  }

  constructor(usagerData) {
    this.accessToken = usagerData.accessToken
    this.role = usagerData.role

    this.codeUsager = usagerData.codeUsager
    this.languePreferee = usagerData.languePreferee

    this.demandeur = usagerData.demandeur
    this.clientData = usagerData.clientData
    this.infosClientJDE = usagerData.infosClientJDE
  }
}
